import { Translation } from '../interfaces/Translation';

const translation: Translation = {
	PageSize: 'ページサイズ',
	PageOrientation: 'ページ方向',
	Format: 'フォーマット',
	DPI: 'DPI（解像度）',
	Generate: '出力',
	LanguageName: '日本語',
	LanguageCode: 'ja'
};

export default translation;
